__turbopack_context__.v({
  "caseStudy": "_-module__Wo91tG__caseStudy",
  "valueOutcome": "_-module__Wo91tG__valueOutcome",
});
